import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getUnviewedRemindersCount } from '../utils/remindersData';
import { setSuccessAlert } from '../store/alert/alertSlice';
// import ReminderFlowModal from './ReminderFlowModal';
// import { useReminderFlowModal } from '../hooks/useReminderFlowModal';
// import ReminderNotificationModal from './ReminderNotificationModal';
// import { useReminderNotifications } from '../hooks/useReminderNotifications';

const RemindersNotification = () => {
  const [lastNotifiedCount, setLastNotifiedCount] = useState(0);
  const dispatch = useDispatch();
  
  // Initialize the reminder flow modal - DISABLED
  // const {
  //   modalState: flowModalState,
  //   showReminderFlowModal,
  //   handleContinue,
  //   handleTurnOffReminders,
  //   handleCloseModal
  // } = useReminderFlowModal();

  // Initialize the reminder notification modals - DISABLED
  // const {
  //   modalState: notificationModalState,
  //   handleSnooze,
  //   handleSnoozeAll,
  //   handleClear,
  //   handleCloseModal: handleCloseNotificationModal
  // } = useReminderNotifications();

  useEffect(() => {
    const checkForNewReminders = () => {
      try {
        const count = getUnviewedRemindersCount();
        
        // Show notification if there are new unviewed reminders
        if (count > 0 && count !== lastNotifiedCount) {
          setLastNotifiedCount(count);
          
          // Use the existing alert system - same as "Signed in successfully"
          const message = count === 1 
            ? "You have 1 new reminder" 
            : `You have ${count} new reminders`;
          
          dispatch(setSuccessAlert(message));
        }
      } catch (error) {
        console.error('Error checking for new reminders:', error);
      }
    };

    // Check immediately
    checkForNewReminders();

    // Check every 30 seconds
    const interval = setInterval(checkForNewReminders, 30000);

    return () => clearInterval(interval);
  }, [lastNotifiedCount, dispatch]);

  // Make the showReminderFlowModal function globally available - DISABLED
  // useEffect(() => {
  //   window.showReminderFlowModal = showReminderFlowModal;
  //   
  //   return () => {
  //     // Clean up on unmount
  //     delete window.showReminderFlowModal;
  //   };
  // }, [showReminderFlowModal]);

  return (
    <>
      {/* ReminderFlowModal - REMOVED (congrats modal) */}
      {/* <ReminderFlowModal
        isOpen={flowModalState.isOpen}
        onClose={handleCloseModal}
        releaseName={flowModalState.releaseName}
        reminderCount={flowModalState.reminderCount}
        onContinue={handleContinue}
        onTurnOffReminders={handleTurnOffReminders}
      /> */}

      {/* ReminderNotificationModal - REMOVED due to bugs */}
      {/* <ReminderNotificationModal
        isOpen={notificationModalState.isOpen}
        onClose={handleCloseNotificationModal}
        currentReminder={notificationModalState.currentReminder}
        remainingReminders={notificationModalState.remainingReminders}
        onSnooze={handleSnooze}
        onSnoozeAll={handleSnoozeAll}
        onClear={handleClear}
        type={notificationModalState.type}
      /> */}
    </>
  );
};

export default RemindersNotification; 